function getFocusableElements(container) {
  if (container) {
    return Array.from(
      container.querySelectorAll(
        "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
      )
    );
  }
  return [];
}
if(document.querySelector('.first-parent')?.hasAttribute('opens-on-hover')){
  document.querySelectorAll('.first-parent').forEach((summary) => {
    summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

    if(summary.nextElementSibling.getAttribute('id')) {
      summary.setAttribute('aria-controls', summary.nextElementSibling.id);
    }
    const subMenu = summary.nextElementSibling;
    let hoverOnFirstParent = false;

    subMenu.addEventListener('mouseover', () => {
      summary.setAttribute('aria-expanded', true);
      summary.closest('details').setAttribute('open', true);
    });
    subMenu.addEventListener('mouseleave', (event) => {
      hoverOnFirstParent = false;
      event.currentTarget.setAttribute('aria-expanded', 'false');
      event.currentTarget.closest('details').removeAttribute('open');
    });

    summary.addEventListener('mouseover', (event) => {
      hoverOnFirstParent = true;
      event.currentTarget.setAttribute('aria-expanded', 'true');
      event.currentTarget.closest('details').setAttribute('open', true);
    });

    summary.addEventListener('mouseleave', (event) => {
      if(hoverOnFirstParent){
        event.currentTarget.setAttribute('aria-expanded', 'false');
        event.currentTarget.closest('details').removeAttribute('open');
      }
    });

    if (summary.closest('header-drawer')) return;
    summary.parentElement.addEventListener('keyup', onKeyUpEscape);
  });
} else {
  document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
    summary.setAttribute('role', 'button');
    summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

    if(summary.nextElementSibling.getAttribute('id')) {
      summary.setAttribute('aria-controls', summary.nextElementSibling.id);
    }

    summary.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    if (summary.closest('header-drawer')) return;
    summary.parentElement.addEventListener('keyup', onKeyUpEscape);
  })
}

// TODO: fix this better
if(!window.location.pathname.includes('/a/resale')) {
  function openAccordion(hash) {
    const accordion = document.querySelector(`${hash} summary`);
    if (!accordion) return;
    accordion.click();
  }

  // Open accordion on page load if address contains hash
  if (window.location.hash) openAccordion(window.location.hash);

  function addClickEventsToAnchors() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor =>
      anchor.addEventListener('click', event => openAccordion(event.target.hash))
    );
  }

  addClickEventsToAnchors();
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  if (elementToFocus) {
    elementToFocus.focus();

    if (elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });

  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });

  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/**
 * @returns {Object} - An object containing Trove language headers based on the selected locale
 * and shipping region.
 */
function getLanguageHeader() {
  const locale = localStorage.getItem('ls-locale');
  if (locale && locale.toLowerCase() !== 'en') {
    const fullLocale = `${locale}-${localStorage.getItem('shippingRegion')}`;
    return {
      // reware-api uses X-Trove-Language to determine the user's preferred language when creating
      // things like trade-ins or wishes.
      'X-Trove-Language': fullLocale,
      // reware-api uses X-Trove-Translation-Lang to determine whether to translate responses.
      'X-Trove-Translation-Lang': fullLocale,
    };
  }
  return {};
}

const { shop } = window?.Shopify || '';

/**
 * A utility function to make fetch requests with additional Trove headers.
 *
 * @param {string} url - The URL to send the request to.
 * @param {object} [options] - Optional options for the fetch request.
 * @param {string} [options.method='POST'] - The HTTP method to use. Defaults to POST.
 * @param {HeadersInit} [options.headers] - Headers to include in the request.
 * @param {BodyInit} [options.body] - The body of the request, for POST/PUT requests.
 * @returns {Promise<any>} - A promise that resolves to the JSON response.
 * @throws {Error} - Throws an error if the network response is not ok.
 */
async function fetchWithAppName(url, options) {
  const resolvedOptions = {
    ...options,
    method: options?.method || 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Trove-App-Name': `shopify:${shop}`,
      ...getLanguageHeader(),
      ...options?.headers,
    },
  };

  let operationName;
  try {
    operationName = new URL(url).searchParams.get('q') || '';
  } catch (parseError) {
    console.warn('Cannot parse provided URL. Proceeding to fetch anway.', parseError);
    operationName = '';
  }

  try {
    const response = await fetch(url, resolvedOptions);
    if (!response.ok) {
      throw new Error(`Failed request ${operationName} with status code ${response.status}`);
    }
    return response;
  } catch (error) {
    console.error(`Error making fetch request for ${operationName}:`, error);
    throw error;
  }
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
    this.open = false;
  }

  addNoScroll() {
    document.querySelector('html').classList.add('noscroll');
  }

  removeNoScroll() {
    document.querySelector('html').classList.remove('noscroll');
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('.menu-drawer__close-submenu-button').forEach(button => button.addEventListener('click', this.onCloseSubmenu.bind(this)));
    this.querySelector('.menu-drawer__close-button')?.addEventListener('click', this.closeMenuDrawer.bind(this));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    this.open = true;
    this.addNoScroll();
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;
    this.open = false;
    this.removeNoScroll();
    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseSubmenu(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }

  isOpen() {
    return this.open;
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    super.openMenuDrawer(summaryElement)
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class InjectModalIntoText extends HTMLElement {
  /**
   * Injects a modal the modal opener into the placeholder (@modal) added to text
   *
   * Usage:
   * <inject-modal-into-text>
   *  <span> text (@modal) </span>
   *  {% render 'modal', block: block %}
   * </inject-modal-into-text>
   */
  constructor() {
    super();
  }

  replaceModalInText(text, modal) {
    return text.replace('(@modal)', modal)
  }

  hasModalPlaceHolder(text) {
    return text.includes('(@modal)');
  }

  connectedCallback() {
    setTimeout(() => { // runs after content is available
      const textContainer = this?.querySelector('.inject-modal__text');
      let text = textContainer.innerHTML;

      const modal = this?.querySelector('modal-opener');
      if (!modal) return;

      if (this.hasModalPlaceHolder(text) && text) {
        // replace @modal with the <modal-opener>
        const newHTML = this.replaceModalInText(text, modal.outerHTML);
        textContainer.innerHTML = newHTML;
      }
      // at this point <modal-opener> is not necesary anymore, is not used or it is already injected and now is duplicated
      modal.remove();
    })
  }
}

customElements.define('inject-modal-into-text', InjectModalIntoText);
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );

    if (this.querySelector('[id^="ModalBack-"]')){
      this.querySelector('[id^="ModalBack-"]').addEventListener(
        'click',
        this.hide.bind(this, false)
      );
    }

    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });

    this.setFontStyleContent();

    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
    this.scrollModalTop();
    acsbTextNodesWrapper(this);
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }

  setFontStyleContent() {
    const fontStyle = this.dataset.contentFont;
    if (fontStyle) {
      const textContent = this.querySelectorAll('p');
      for (let text of textContent) {
        text.classList.add(fontStyle);
      }
    }
  }

  scrollModalTop() {
    this.scroll(0, 0);
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class EagerMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('.video-section__poster');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {

      const deferredElement = this.querySelector('video, model-viewer, iframe');

      const setLoaded = () => {
        this.setAttribute('loaded', true);
        if (focus) deferredElement.focus();
      };

      // Set autoplay query param if Vimeo (correct inadvertent autoplay on page load)
      if (deferredElement.classList.contains('js-vimeo')) {
        deferredElement.addEventListener('load', setLoaded);
        deferredElement.src += '?autoplay=1';
      } else {
        setLoaded();
      }
    }
  }
}

customElements.define('eager-media', EagerMedia);

class SliderComponent extends HTMLElement {
  constructor(args) {
    super();
    this.render(args);
  }

  render(args) {
    this.slider = this.querySelector('[id^="Slider-"]');

    if (args?.slider) {
      this.slider = args.slider;
    }
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    if (args?.sliderItems) {
      this.sliderItems = args.sliderItems;
    }
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    if (args?.prevButton) {
      this.prevButton = args.prevButton;
    }
    this.nextButton = this.querySelector('button[name="next"]');
    if (args?.nextButton) {
      this.nextButton = args.nextButton;
    }

    this.mq1 = false;
    this.mq2 = false;

    if (!this.slider || !this.nextButton) return;

    this.initPages(args);
    const resizeObserver = new ResizeObserver(entries => this.initPages(args));
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  connectedCallback(){
    let thumbs = this.querySelector('.thumbnail-list');
    if (thumbs){
      this.mq1 = window.matchMedia('(min-width: 750px)');
      this.mq2 = window.matchMedia('(min-width: 990px)');

      this.mq1.addEventListener("change", this.onMediaChange.bind(this));
      this.mq2.addEventListener("change", this.onMediaChange.bind(this));

      this.onMediaChange(this.mq1);
    }
  }

  onMediaChange(mq){
    let thumbs = this.querySelector('.thumbnail-list');

    //reset previously set values so we can get the default css values to measure with
    thumbs.style.gridTemplateColumns = '';
    thumbs.querySelector('li').style.gridColumnStart = '';

    let computedStyle =  window.getComputedStyle(thumbs)
    let columns = computedStyle.getPropertyValue("grid-template-columns").split(" ").length;
    let center = computedStyle.getPropertyValue("justify-content") == 'center' ? true : false;
    //if the thumbs are less than the columns we need to manually offset the thumbs in order to 'center' them
    if (thumbs.children.length < columns && center){
      //if the thumbs and columns are not both odd or even then subtract 1 from the columns so the sides can be balanced before centering
      if ((thumbs.children.length % 2 > 0 && columns % 2 == 0) || (thumbs.children.length % 2 == 0 && columns % 2 > 0)){
        columns = columns-1;
        thumbs.style.gridTemplateColumns = `repeat(${columns}, 1fr)`;
      }

      let offset = (columns - thumbs.children.length)/2 + 1;
      thumbs.querySelector('li').style.gridColumnStart = offset;
    }
  }

  initPages(args) {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update(args);
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update(args) {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.slider.scrollWidth <= this.slider.clientWidth){
      if (args?.hideButtons) {
        this.prevButton.style.display = 'none';
        this.nextButton.style.display = 'none';
        if (args?.centerOptions) {
          this.slider.style.justifyContent = 'center';
        }
      }
      this.prevButton.setAttribute('disabled', 'disabled');
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
        this.prevButton.classList.add('disabled');
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.classList.remove('disabled');
        this.prevButton.removeAttribute('disabled', 'disabled');
      }

      if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
        this.nextButton.classList.add('disabled');
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.classList.remove('disabled');
        this.nextButton.removeAttribute('disabled', 'disabled');
      }
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = Math.ceil(this.slider.clientWidth + this.slider.scrollLeft - offset);
    return Math.ceil(element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next' ?
        this.slider.scrollLeft + (step * this.sliderItemOffset) :
        this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      top: 0,
      left: this.slideScrollPosition,
      behavior: 'auto'
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  connectedCallback() {
    this.setSamePdp();
    setTimeout(() => this.onVariantChange());
  }

  onVariantChange(ev) {
    this.updateOptions();
    if (isMixedStyles) {
      const option = ev?.target?.getAttribute('data-option');
      const isUnavailableSelection = ev?.target?.classList.contains('disabled');
      if (option === 'size') {
        updateQueryParams({
          size: ev.target.value,
          ...(isUnavailableSelection ? {
            color: '',
            condition: undefined,
          } : {}),
        });
      } else if (option === 'condition') {
        updateQueryParams({
          condition: ev.target.value,
          ...(isUnavailableSelection ? {
            color: '',
            size: undefined,
          } : {}),
        });
      }
    } else {
      sessionStorage.setItem('variantOptions', this.options);
    }

    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    if (!this.currentVariant && !isMixedStyles) {
      sessionStorage.setItem('unavailableItem', true);
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      sessionStorage.removeItem('unavailableItem');
      this.updateMedia();
      if (!isMixedStyles) {
        this.updateURL();
      }
      this.updateVariantInput();
      if (!isMixedStyles) {
        this.renderProductInfo();
      }
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}${window.location.search}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant?.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked')?.value === variant.option1);
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked')?.value;
      const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue)
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant?.id;

    fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant?.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        this.toggleAddButton(!this.currentVariant?.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    if (!button) return;
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  setSamePdp() {
    sessionStorage.removeItem('samePdp');
    setTimeout(() => {
      document.querySelectorAll('.product-form__input-wrapper').forEach(anchor => {
        anchor.addEventListener('click', () => sessionStorage.setItem('samePdp', true))
      })
    });
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input, option')).find((radio) => radio.checked || radio.selected)?.value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            // TODO: check if cdn(urls) are resolved correctly
            // we found some issues in mixed-styles-card-product where script didn't fire...
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class Tooltip extends HTMLElement {
  constructor() {
    super();

    this.tooltipContent = document.createElement('div');
    this.tooltipContent.style.display = 'none';
    this.tooltipContent.style.position = 'absolute';
    this.tooltipContent.classList.add('tooltip-bubble');
    this.appendChild(this.tooltipContent);

    this.addEventListener('click', this.showTooltip.bind(this));
    this.addEventListener('mouseover', this.showTooltip.bind(this));
    this.addEventListener('mouseout', this.hideTooltip.bind(this));
  }

  connectedCallback() {
    const tooltipHTML = this.getAttribute('data-tooltip');
    this.tooltipContent.innerHTML = tooltipHTML;
  }

  showTooltip() {
    this.tooltipContent.style.display = 'block';
    acsbTextNodesWrapper(this);
  }

  hideTooltip() {
    this.tooltipContent.style.display = 'none';
  }
}

customElements.define('tool-tip', Tooltip);

function acsbTextNodesWrapper(root) {
  // wraps text nodes, that are inside the root node and don't have a wrapper in a span

  // each node needs to wrapped on a tag so accessibe can add the text magnifier correctly
  if (!global.isAccessiBeEnabled || root.getAttribute('data-acsb-wrap')) {
    return;
  };

  root.setAttribute('data-acsb-wrap', true);

  function traverse(node) {
    const childNodes = node.childNodes;

    if (childNodes.length === 1 && childNodes[0].nodeName === "#text") {
      return;
    } else if (!node || !childNodes.length) {
      return;
    };

    for (let currentNode of childNodes) {
      if (currentNode.nodeName === "#text" && currentNode.textContent.trim().length) {
        const wrapper = document.createElement('span');
        wrapper.setAttribute('data-acsb-tooltip-bound', true);
        wrap(currentNode, wrapper);
      }
      traverse(currentNode);
    }
  }

  function wrap(el, wrapper) {
    if (el && el.parentNode) {
      el.parentNode.insertBefore(wrapper, el);
      wrapper.appendChild(el);
    }
  }

  traverse(root);
}

// adpated from a previously included Shopify function, an example can be found in this gist:
// https://gist.github.com/stewartknapman/8d8733ea58d2314c373e94114472d44c?permalink_comment_id=3141993#gistcomment-3141993
// for all supported money formats see:
// https://help.shopify.com/en/manual/markets/pricing/currency-formatting#currency-formatting-options
function formatMoney(price, formatOverride) {
  if (typeof price === "string") {
    price = price.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = window.moneyFormat || "{{ amount }}";

  const formatWithDelimiters = (
    number,
    precision = 2,
    thousands = ',',
    decimal = '.'
  ) => {
    if (isNaN(number) || number === null) return 0;

    const parts = (number / 100.0).toFixed(precision).split(".");
    const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
    const cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  return formatString.replace(placeholderRegex, (_match, formatName) => {
    formatName = formatOverride || formatName;
    switch (formatName) {
      case "amount":
        return formatWithDelimiters(price, 2);
      case "amount_no_decimals":
        return formatWithDelimiters(price, 0);
      case "amount_with_comma_separator":
        return formatWithDelimiters(price, 2, ".", ",");
      case "amount_no_decimals_with_comma_separator":
        return formatWithDelimiters(price, 0, ".", ",");
      case "amount_with_apostrophe_separator":
        return formatWithDelimiters(price, 2, "'", ".");
      default:
        console.warn(`Unknown currency format '${formatName}'.`);
        return `{unknown currency format: ${formatName}}`;
    }
  })
}

function formatMoneyForTradein(price) {
  const formatString = window.moneyFormat || '{{ amount }}';
  
  let formatOverride;
  if (window.shouldHideCentsForTradein) {
    if (/\{\{\s*amount\s*\}\}/.test(formatString)) {
      formatOverride = 'amount_no_decimals';
    } else if (/\{\{\s*amount_with_comma_separator\s*\}\}/.test(formatString)) {
      formatOverride = 'amount_no_decimals_with_comma_separator';
    }
  }
  return formatMoney(price, formatOverride);
}

/**
 * Construct a new `URLSearchParams` instance that applies updates to an initial value.
 * @param {*} initialSearch The initial value. Can be any value that can be passed to the
 * `URLSearchParams` constructor including a query string with or without initial question mark or a
 * `URLSearchParams` instance. If a `URLSearchParams` instance, the provided instance will NOT be
 * modified by this call.
 * @param {*} patch An object whose keys are query string keys and whose values are one of the
 * following:
 * - a string to set the key to the provided value. Any existing values for the provided key will be
 *   discarded.
 * - an array to indicate that the provided key should be present multiple times in the resulting
 *   search params with the provided values. Any existing values for the provided key will be
 *   discarded. An empty array has the same effect as `null` or `undefined`.
 * - `null` or `undefined` to indicate that the given key should be omitted from the resulting
 *   search params
 * - Any other value will be treated like a string using string coercion (see
 *   https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#string_coercion)
 * @returns A new `URLSearchParams` instance including the specified patch.
 */
function searchParamsFromPatch(initialSearch, patch) {
  const clone = new URLSearchParams(initialSearch);
  for (const [key, value] of Object.entries(patch)) {
    if (value === null || value === undefined) {
      clone.delete(key);
    } else if (Array.isArray(value)) {
      clone.delete(key);
      for (const innerValue of value) {
        clone.append(key, innerValue);
      }
    } else {
      clone.set(key, value);
    }
  }
  return clone;
}

/**
 * Update the current query string by applying the provided patch.
 * @param {*} patch An object whose keys are query string keys and whose values are one of the
 * following:
 * - a string to set the key to the provided value. Any existing values for the provided key will be
 *   discarded.
 * - an array to indicate that the provided key should be present multiple times in the query string
 *   with the provided values. Any existing values for the provided key will be discarded. An empty
 *   array has the same effect as `null` or `undefined`.
 * - `null` or `undefined` to indicate that the given key should be omitted from the query string
 * - Any other value will be treated like a string using string coercion (see
 *   https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String#string_coercion)
 * @param {*} param1 An optional object with the following optional properties:
 * - `historyAction` -- One of `replace` or `push` indicating whether the operation should call
 *   `history.replaceState` or `history.pushState`. Defaults to `replace`. See
 *   https://developer.mozilla.org/en-US/docs/Web/API/History/replaceState and
 *   https://developer.mozilla.org/en-US/docs/Web/API/History/pushState for the differences between
 *   the two operations.
 */
function updateQueryParams(patch, { historyAction = 'replace' } = {}) {
  const updatedParams = searchParamsFromPatch(window.location.search, patch);
  let newQueryString = `${updatedParams}`;
  if (newQueryString) {
    newQueryString = `?${newQueryString}`;
  }
  history[`${historyAction}State`](
    history.state,
    '',
    `${window.location.pathname}${newQueryString}${window.location.hash}`,
  );
}
